import { addReducer } from "incremental-redux-reducers";

const initialState = {
  patients: [],
  meta: {}
};

export default addReducer(
  "locationPatientHighRisk",
  function locationPatientHighRiskReducer(state = initialState, action) {
    switch (action.type) {
      case "LOCATION_HIGHRISK_PATIENT_LOAD":
        return {
          ...state,
          patients: action.patients,
          meta: action.meta
        };
      case "LOCATION_HIGHRISK_PATIENT_LOAD_MORE":
        return {
          patients: [...state.patients, ...action.patients],
          meta: action.meta
        };
      default:
        return state;
    }
  }
);
